import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { CanComponentDeactivate } from '../../services/unsaved-changes.guard';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { InferenceService } from '../../services/api-services/inference.service';
import { UserSessionsService, UserSession } from '../../services/api-services/user-sessions.service';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { environment } from '../../environments/environment';
import { RouterModule } from '@angular/router';
import { DialogComponent } from '../../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { FeatherModule } from 'angular-feather';


@Component({
    selector: 'app-estimator-app',
    standalone: true,
    imports: [MatCardModule, MatMenuModule, MatPaginatorModule, MatTableModule, NgIf, MatCheckboxModule, MatProgressSpinnerModule,
    MatInputModule, ReactiveFormsModule, MatButtonModule, MatTabsModule, MatFormFieldModule, FormsModule,
    MatProgressBarModule, MatSelectModule, MatOptionModule, RouterModule, MatButtonToggleModule, CommonModule, MatIconModule, FeatherModule],
    templateUrl: './estimator-app-dual.component.html',
    styleUrl: './estimator-app-dual.component.scss'
})
export class EstimatorAppDualComponent implements OnInit, CanComponentDeactivate {

    public fullProductPhoto: string | undefined = undefined;
    public labelPhoto: string | undefined = undefined;

    fullProductLoading = false;
    labelPhotoLoading = false;

    estimateButtonDisabled = true;

    capturePhotoBtnName = 'Take photo of entire product';
    labelPhotoBtnName = 'Take photo of product label';
    submitDisabled = false;
    isLoading = false;
    predictionMade = false;
    price = 0;

    editingPrice = false;
    updateBtnName = 'Modify';

    updateBtnDisabled = false;
    originalPrice = 0;
    priceNotAccurateMessage = 'Adjust Price & Improve';

    isAddingToSession = false;
    activeSessionName = '';
    private activeSessionId: number | null = null;

    outputBrand = '';
    outputColor = '';
    outputItem = '';
    outputMaterial = '';

    originalOutputBrand = '';
    originalOutputColor = '';
    originalOutputItem = '';
    originalOutputMaterial = '';

    editingDetails = false;
    editDetailsBtnName = "Edit product info";
    editButtonIcon = 'edit'

    showInfoText = false;

    showAlertInfo = false;
    alertInfoText = '';

    showSuccessInfo = false;
    successInfoText = '';

    showAlertInfoPricing = false;
    alertInfoTextPricing = '';

    undoLastUpdateBtnDisabled = true;

    lastImageId: string | undefined = undefined;
    lastBrandId: string | undefined = undefined;
    lastClusterId: string | undefined = undefined;
    updatesResult: any | undefined = undefined;

    private imageEmbedding: any[] = [];
    private brandEmbedding: any[] | string = "None";
    private brandRepresentative = '';
    scenarioMessage = '';

    selectedTab = 0;
    estimationsTabDisabled = true;
    estimationsLoading = false;
    condition = 'Good';
    age = 'Current';

    updatePriceForProductBtnName = "Update & Continue"
    updateLoading = false;

    pricingLoading = false;
    pricingTabDisabled = true;

    constructor(private apiInferenceService: InferenceService,
       private userSessionsService: UserSessionsService,
       private changeDetector: ChangeDetectorRef, private dialog: MatDialog
    ) {
      // this.toggleService.toggle();
    }

    hasUnsavedChanges(): boolean {
      return this.fullProductPhoto !== undefined;
    }

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent): void {
      if (this.hasUnsavedChanges()) {
        event.preventDefault();
        event.returnValue = '';
      }
    }

    canDeactivate(): boolean {
      if (this.hasUnsavedChanges()) {
        return window.confirm('Are you sure you want to leave this page?');
      }
      return true;
    }

    ngOnInit(): void {
      this.refreshView();
    }

    refreshView() {
      this.predictionMade = false;

      this.showAlertInfo = false;
      this.showSuccessInfo = false;
      this.showAlertInfoPricing = false;

      this.isLoading = true;
      this.submitDisabled = false;
      this.capturePhotoBtnName = 'Take photo of entire product'
      this.labelPhotoBtnName = 'Take photo of the product label';

      this.outputBrand = 'unknown';
      this.outputColor = 'unknown';
      this.outputItem = 'unknown';
      this.outputMaterial = 'unknown';

      this.price = 0;
      this.editingPrice = false;

      // Load active session
      this.userSessionsService.getActiveSession().subscribe({
        next: response => {
          if (response.session) {
            this.activeSessionId = response.session.id;
            this.activeSessionName = response.session.name;
            this.isAddingToSession = true;
          } else {
            this.activeSessionId = null;
            this.activeSessionName = '';
            this.isAddingToSession = false;
          }
        },
        error: () => {
          this.activeSessionId = null;
          this.activeSessionName = '';
          this.isAddingToSession = false;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });

    }

    predict() {
      this.estimationsTabDisabled = false;
      this.selectedTab = 1;
      this.estimationsLoading = true;

      this.condition = 'Good';
      this.age = 'Current';

      this.showAlertInfo = false;
      this.showSuccessInfo = false;

      this.changeDetector.detectChanges();

      this.inferenceProductDetails();
    }

    analyzeResponseProductDetails(response: any) {
      if (Object.keys(response).includes('message')) {
        if (response['message'] === 'Invalid photo') {
          window.alert('Invalid photo. Please try again.');
        }
      }
      if (Object.keys(response).includes('brand')) {
        this.outputBrand = response['brand'];

        if (this.outputBrand === 'unknown') {
          this.alertInfoText = "The product's brand could not be identified. Please edit the brand field and save your changes.";
          this.showAlertInfo = true;
        } else {
          this.alertInfoText = "";
          this.showAlertInfo = false;
        }
      }
      if (Object.keys(response).includes('item')) {
        this.outputItem = response['item'];
      }
      if (Object.keys(response).includes('material')) {
        this.outputMaterial = response['material'];
      }
      if (Object.keys(response).includes('color')) {
        this.outputColor = response['color'];
      }
    }

    analyzeResponsePricing(response: any) {
      if (Object.keys(response).includes('price')) {
        this.price = Number(response["price"]);
        this.originalPrice = Number(response["price"]);
      }
      if (Object.keys(response).includes('brand_representative')) {
        this.brandRepresentative = response["brand_representative"];

        if (this.brandRepresentative === 'unbranded') {
          this.alertInfoTextPricing = "The product's brand could not be identified. Please edit the brand field in 'Estimations' and save your changes.";
          this.showAlertInfoPricing = true;
        }
        else if (this.brandRepresentative === 'not_found') {
          this.alertInfoTextPricing = 'The AI model has not encountered this brand before. The price will be estimated based on extrapolated data.';
          this.showAlertInfoPricing = true;
        } else {
          this.alertInfoTextPricing = '';
          this.showAlertInfoPricing = false;
        }
      }
      if (Object.keys(response).includes('scenario_message')) {
        this.scenarioMessage = response["scenario_message"];
      }

    }

    inferenceProductDetails() {
      this.apiInferenceService.uploadPhotosAndPredictDetails(this.fullProductPhoto, this.labelPhoto).subscribe({
        next: response => {
          if (!environment.production) {
            console.log(response);
          }
          this.analyzeResponseProductDetails(response);
        },
        error: error => {
          if (!environment.production) {
            console.log(error);
          }
          window.alert('An error occurred while trying to get images details. Please contact admin.');
        },
        complete: () => {
          this.estimationsLoading = false;
          this.changeDetector.detectChanges();
        }
      })
    }

    getPrice() {
      this.selectedTab = 2;
      this.pricingLoading = true;
      this.pricingTabDisabled = false;
      this.changeDetector.detectChanges();
      this.pricingProduct();
    }

    pricingProduct() {
      this.apiInferenceService.pricingProduct(
        this.outputBrand,
        this.age,
        this.condition,
        this.fullProductPhoto
      ).subscribe({
        next: response => {
          if (!environment.production) {
            console.log(response);
          }
          this.analyzeResponsePricing(response);
        },
        error: error => {
          if (!environment.production) {
            console.log(error);
          }
          this.selectedTab = 1;
          window.alert('An error occurred while trying to get price for given product.');
        },
        complete: () => {
          this.predictionMade = true;
          this.pricingLoading = false;
        }
      })
    }

    updateAndContinue() {
      console.log(this.price);
    }

    selectCondition(condition: string) {
      this.condition = condition;
    }

    selectAge(age: string) {
      this.age = age;
    }

    onCancelSessionInsertion() {
      this.isAddingToSession = false;
      this.activeSessionId = null;
      this.activeSessionName = '';
      this.userSessionsService.clearActiveSession().subscribe({
        next: response => {
          if (!environment.production) {
            console.log(response);
          }
        },
        error: error => {
          if (!environment.production) {
            console.log(error);
          }
        }
      });
    }

    private uploadedImageResponse(response: any) {
      this.showAlertInfo = false;
      this.showInfoText = false;
      this.brandRepresentative = 'None';
      this.brandEmbedding = [];

      if (Object.keys(response).includes('brand_representative')) {
        if (response['brand_representative'] === 'None') {
          this.alertInfoText = 'The AI model has not encountered this brand before. The price will be estimated based on extrapolated data.';
          this.showAlertInfo = true;
        } else if (response['brand_representative'] === 'unbranded') {
          this.alertInfoText = "The product's brand could not be identified. Please edit the brand field and save your changes.";
          this.showAlertInfo = true;
        } else {
          this.brandRepresentative = response['brand_representative'];
          this.showAlertInfo = false;
        }
      }

      if (Object.keys(response).includes('output')) {
        if (response['output']['item'] === 'unknown') {
          this.alertInfoText = "The product could not be identified. Please edit the table fields and save your changes.";
          this.showAlertInfo = true;
        }
      }

      for (const key of Object.keys(response)) {
        if (key === 'image_embedding') {
          this.imageEmbedding = response[key];
        } else if (key === 'output') {
          this.outputBrand = response[key]['brand'];
          this.outputColor = response[key]['color'];
          this.outputItem = response[key]['item'];
          this.outputMaterial = response[key]['material'];
        } else if (key === 'price') {
          this.price = Number(response[key]);
          this.originalPrice = response[key];
          this.predictionMade = true;
          this.updateBtnDisabled = false;
        } else if (key === 'brand_embedding') {
          this.brandEmbedding = response[key];
        }
      }
    }

    openFullFileSelector() {
      const fileInput = document.getElementById('fullFileInput') as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
    }

    openLabelFileSelector() {
      const fileInput = document.getElementById('labelFileInput') as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
    }

    removeFullPhoto() {
      this.fullProductPhoto = undefined;
      this.estimateButtonDisabled = true;
      const fileInput = document.getElementById('fullFileInput') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }

      this.changeDetector.detectChanges();
    }

    removeLabelPhoto() {
      this.labelPhoto = undefined;

      const fileInput = document.getElementById('labelFileInput') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }

      this.changeDetector.detectChanges();
    }

    onFileSelectedFullItemPhoto(event: Event) {
      const fileInput = event.target as HTMLInputElement;

      this.loadResizedPhoto(fileInput, 'product');

      this.estimateButtonDisabled = false;
      this.estimationsTabDisabled = true;
      this.pricingTabDisabled = true;

      this.changeDetector.detectChanges();
    }

    onFileSelectedLabelPhoto(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      this.loadResizedPhoto(fileInput, 'label');
    }

    checkTableInput() {
      if (this.outputBrand === 'unknown' || this.outputBrand === "") {
        this.outputBrand = "unknown";
        this.alertInfoText = "The product's brand could not be identified. Please edit the brand field and save your changes.";
        this.showAlertInfo = true;
      } else {
        this.showAlertInfo = false;
      }
      if (this.outputColor === "") {
        this.outputColor = 'unknown';
      }
      if (this.outputItem === "") {
        this.outputItem = 'unknown';
      }
      if (this.outputMaterial === "") {
        this.outputMaterial = 'unknown';
      }
    }

    onEditItemDetails() {
      if (!this.editingDetails) {
        this.editingDetails = true;
        this.updateBtnDisabled = true;

        this.originalOutputBrand = this.outputBrand;
        this.originalOutputColor = this.outputColor;
        this.originalOutputItem = this.outputItem;
        this.originalOutputMaterial = this.outputMaterial;

        this.editDetailsBtnName = 'Save changes';
        this.editButtonIcon = 'save';
      } else {
        this.editingDetails = false;
        this.editDetailsBtnName = "Edit product info";
        this.editButtonIcon = 'edit';
        this.updateBtnDisabled = false;

        this.submitDisabled = false;

        this.checkTableInput();

        this.changeDetector.detectChanges();

      }
    }

    onCancelEditingDetails() {
      this.editingDetails = false;
      this.editDetailsBtnName = "Edit product info";
      this.editButtonIcon = 'edit';
      this.updateBtnDisabled = false;

      this.outputBrand = this.originalOutputBrand;
      this.outputColor = this.originalOutputColor;
      this.outputItem = this.originalOutputItem;
      this.outputMaterial = this.originalOutputMaterial;

    }

    priceOnChange() {
      if (typeof this.price === 'number') {
        this.updateBtnDisabled = false;
      } else {
        this.updateBtnDisabled = true;
      }
    }

    editPrice() {
      if (this.editingPrice === false) {
        this.editingPrice = true;
        this.updateBtnDisabled = true;
        this.submitDisabled = true;
        this.priceNotAccurateMessage = 'Adjust Price & Improve';
      } else {
        this.originalPrice = this.price;
        this.editingPrice = false;
        this.updateBtnDisabled = false;
        this.submitDisabled = false;
      }
      this.changeDetector.detectChanges();
    }

    cancelUpdate() {
      this.price = this.originalPrice;
      this.editingPrice = false;
      this.submitDisabled = false;
      this.updateBtnName = 'Modify'
      this.updateBtnDisabled = false;
    }

    scrollToBottom(): void {
      if (this.isPageScrollable()) {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      } else {
        console.log('The page is not scrollable');
      }
    }

    isPageScrollable(): boolean {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      return scrollHeight > clientHeight;
    }

    continueAndUpdateModels() {
      this.updateLoading = true;
      this.submitDisabled = true;
      this.changeDetector.detectChanges();

      this.updateDualProductPrice();
    }

    updateDualProductPrice() {
      this.apiInferenceService.updatePriceForProductDual(
        this.fullProductPhoto,
        this.labelPhoto,
        this.price,
        this.outputItem,
        this.outputMaterial,
        this.outputColor,
        this.outputBrand,
        this.brandRepresentative,
        this.age,
        this.condition
      ).subscribe({
        next: response => {
          if (!environment.production) {
            console.log('Updating price for product');
            console.log(response);
          }
        },
        error: error => {
          if (!environment.production) {
            console.log(error);
          }
          this.updateLoading = false;
          this.submitDisabled = false;

          this.alertInfoTextPricing = 'Something went wrong when trying to update the models. Please try again or contact admin.';
          this.showAlertInfoPricing = true;

          this.showSuccessInfo = false;

          this.changeDetector.detectChanges();
        },
        complete: () => {
          this.updateLoading = false;
          this.submitDisabled = false;
          
          this.successInfoText = 'The AI model has been successfully updated.';
          this.showSuccessInfo = true;

          this.changeDetector.detectChanges();
        }
      })
    }

    startAgain() {
      this.selectedTab = 0;
      this.removeFullPhoto();
      this.removeLabelPhoto();
      this.refreshView();
      this.estimationsTabDisabled = true;
      this.pricingTabDisabled = true;
      this.changeDetector.detectChanges();
    }

    showUndoDialog() {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '500px',
        autoFocus: true,
        restoreFocus: true,
        data: {
          dialogTitle: 'Undo Last Update',
          content: "This action will undo the last update. Do you want to proceed?",
          newButton: true,
          newButtonName: 'Undo Update',
          createFile: false
        }
      });

      dialogRef.componentInstance.buttonClicked.subscribe(() => {
        this.undoLastUpdate();
        dialogRef.close();
      });
    }

    undoLastUpdate() {
      // this.contentLoading = true;
      this.changeDetector.detectChanges();
      if (this.lastImageId === undefined || this.lastBrandId === undefined || this.lastClusterId === undefined || this.updatesResult === undefined) {
        return;
      }
      this.apiInferenceService.undoUpdate(this.lastImageId, this.lastBrandId, this.lastClusterId, this.updatesResult).subscribe({
        next: response => {
          if (!environment.production) {
            console.log(response);
          }
        },
        error: error => {
          console.log(error);
          window.alert('An error occurred while trying to undo last update.');
          // this.contentLoading = false;
          this.changeDetector.detectChanges();
        },
        complete: () => {
          this.undoLastUpdateBtnDisabled = true;
          // this.contentLoading = false;
          this.changeDetector.detectChanges();
          // this.saveTableChanges();
        }
      });
    }

    private loadResizedPhoto(fileInput: any, photoType: string, maxDimension = 1000) {
        if (!fileInput.files || !fileInput.files[0]) {
          this.fullProductLoading = false;
          this.labelPhotoLoading = false;
          return;
        }

        if (photoType === 'label') {
          this.labelPhotoLoading = true;
        } else if (photoType === 'product') {
          this.fullProductLoading = true;
        }
        this.changeDetector.detectChanges();

        const file = fileInput.files[0];
        console.log(`Original file size: ${file.size} bytes`);

        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
        const img = new Image();
        img.onload = () => {
          let { width, height } = img;
          if (Math.max(width, height) > maxDimension) {
            const scale = maxDimension / Math.max(width, height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            console.error('Canvas rendering context is not available.');
            return;
          }
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            blob => {
              if (!blob) {
                console.error('Failed to create blob from canvas.');
                return;
              }
              console.log(`Resized blob size: ${blob.size} bytes`);

              const reader2 = new FileReader();
              reader2.onload = (e2: ProgressEvent<FileReader>) => {
                if (photoType === 'label') {
                  this.labelPhoto = e2.target?.result as string;
                  this.labelPhotoLoading = false;
                } else if (photoType === 'product') {
                  this.fullProductPhoto = e2.target?.result as string;
                  this.estimateButtonDisabled = false;

                  this.fullProductLoading = false;
                }
                this.changeDetector.detectChanges();
              };
              reader2.readAsDataURL(blob);
            },
            'image/jpeg',
            0.8 // quality 0.0–1.0
          );
        };

        img.onerror = () => {
          console.error('Failed to load image for resizing.');
        };

        // Kick off the image load
        img.src = e.target?.result as string;
      };

      reader.onerror = () => {
        console.error('Failed to read file as Data-URL.');
      };

      reader.readAsDataURL(file);
    }

}

